module.exports = __webpack_public_path__ + "static/img/场馆展示后蓝背景.4112fbcb.png";